import { Text } from '@hhgtech/hhg-components/mantine'
import { Plus } from '@hhgtech/icons/core'
import { AspectRatio, Box, Flex, StackProps } from '@mantine/core'

import { DEFAULT_IMG } from 'interfaces/constants'

import useStyles from './index.styles'

type Props = {
  title: string
  icon: string
} & StackProps

export const TrustfulItem = ({
  title,
  icon,
  styles,
  className,
  classNames,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'TrustfulItem',
    styles,
    classNames,
  })
  return (
    <Flex className={cx(classes.root, className)} {...rest}>
      <Text size="h5" as="h5" className={classes.heading}>
        {title}
      </Text>
      <Box className={classes.icon}>
        <AspectRatio ratio={1}>
          <img loading="lazy" src={icon || DEFAULT_IMG} alt={title} />
        </AspectRatio>
      </Box>
      <Flex
        className={cx(classes.iconBtn, 'icon-wrapper')}
        justify={'center'}
        align={'center'}
      >
        <Plus className="icon" color="currentColor" size={16} />
      </Flex>
    </Flex>
  )
}
